import { useCallback } from "react";

import {
	formatIfApolloError,
	parseTransactionIdFromGraphQLErrors,
} from "../formatErrors";

import { useLogger } from "@/contexts/logger";

export default function useCaptureGraphQLError() {
	const { captureException } = useLogger();

	return useCallback(
		(error: unknown) => {
			if (!error) {
				return;
			}

			// The error itself, not a copy: `CombinedGraphQLErrors.is` recognises
			// the instance, and a spread copy is a plain object.
			const transactionId = parseTransactionIdFromGraphQLErrors(error);
			const tags = transactionId ? { "transaction-id": transactionId } : {};

			captureException(formatIfApolloError(error), { tags });
		},
		[captureException],
	);
}
